import { ERowType } from 'src/app/project/shared/enums/row-type.enum';
import Table, { FETCH_ALL_PAGE_SIZE } from '../../site-table/custom-table/table/Table';
import { ADD_COLLAPSED_GROUP, SET_ALL_GROUPS_COLLAPSED } from '../../site-table/table.ui.store';
import Timeline from '../../site-timeline/Timeline';

export function bulkGroup(groupedObject: Timeline | Table): void {
  SET_ALL_GROUPS_COLLAPSED(true);
  groupedObject.items.forEach((item) => {
    if (
      item.type === ERowType.HEADER ||
      item.type === ERowType.GROUP_1 ||
      item.type === ERowType.GROUP_2 ||
      item.type === ERowType.GROUP_3
    ) {
      ADD_COLLAPSED_GROUP(item.id);
    }
  });

  if (groupedObject instanceof Timeline) {
    (groupedObject as Timeline).sortTimeline();
  } else {
    const table = groupedObject as Table;

    table.sortTable();
    table.loadNextPage({ size: FETCH_ALL_PAGE_SIZE });
  }
}
